import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactTable from 'react-table';
import moment from 'moment';

import common from '../../../../../common/common';
import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { scBlue100 } from '../../../../../constants/systemColors';
import { NSPS_SITE } from '../../../../../services/i18n/namespaces';
import { RT_TEXT_OVERWRITE } from '../../../../../services/i18n/react-table';

export default function InformedConsentHistoryModal({ modalBox, onFileOpen, ssuId, forms }) {
  const { t } = useTranslation();
  const onClose = () => {
    modalBox.close();
  };

  const columns = [
    {
      Header: t('informedConsent.nameOfIcf', { ns: NSPS_SITE }),
      accessor: 'name',
      sortable: true,
      Cell: row => {
        const { filename, formId } = row.original;
        const { name } = row.row;
        return (
          <span style={{ color: scBlue100, cursor: 'pointer' }} onClick={() => onFileOpen(filename, formId, ssuId)}>
            {name}
          </span>
        );
      }
    },
    {
      Header: t('informedConsent.icfIrbApprovalDate', { ns: NSPS_SITE }),
      accessor: 'publishDate',
      Cell: row => {
        const { publishDate } = row.row;
        return common.formatDate(publishDate, 'DD/MMM/YYYY');
      },
      sortable: true,
      sortMethod: common.dateComparator
    },
    {
      Header: t('informedConsent.dateUploaded', { ns: NSPS_SITE }),
      accessor: 'uploadDate',
      Cell: row => {
        const { uploadDate } = row.row;
        const zonedDate = moment.tz(uploadDate, moment.tz.guess());
        return common.formatDate(zonedDate, 'DD/MMM/YYYY hh:mm a');
      },
      sortable: true,
      sortMethod: common.dateComparator
    },
    {
      Header: t('informedConsent.version', { ns: NSPS_SITE }),
      accessor: 'version',
      Cell: row => {
        const { version } = row.row;
        return version ? <span className="cursor-pointer"> {version} </span> : '--';
      }
    }
  ];

  return (
    <>
      <ModalBoxes.Header onClose={onClose}>{t('informedConsent.formsHistory', { ns: NSPS_SITE })}</ModalBoxes.Header>
      <ModalBoxes.Body>
        <div className="col-12 border px-0 site-info-table">
          <ReactTable
            {...RT_TEXT_OVERWRITE}
            data={forms}
            columns={columns}
            minRows={1}
            multiSort
            className="table activity-table table-responsive-sm m-0 "
            showPagination
            nextText=">>"
            previousText="<<"
            defaultPageSize={5}
            noDataText={t('informedConsent.noDataText', { ns: NSPS_SITE })}
            sortable
          />
        </div>
      </ModalBoxes.Body>
    </>
  );
}
